import styled from 'styled-components';

export const SectionStyled = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
`;
